import * as clsApi from "./classroomApi";
import { ClassroomDetails } from "@/stores/classroomStore_I";

type ClassroomDetailsResponseDTO = {
	result: {
		classroom: ClassroomDetails;
	};
};

export const getClassroomDetails = async (
	classroomId: string,
	includeStudents: boolean,
	includeTeachers: boolean,
	includeSchedule: boolean,
	includeRules: boolean,
	type: "CLASSROOM" | "GROUP",
	sourceId: string,
	teacherId: string
): Promise<{ classroom: ClassroomDetails }> => {
	if (type === "CLASSROOM") {
		const response = await clsApi
			.Get<ClassroomDetailsResponseDTO>(
				`classrooms/${encodeURIComponent(classroomId)}?
		includeStudents=${encodeURIComponent(includeStudents)}
		&includeTeachers=${encodeURIComponent(includeTeachers)}
		&includeSchedule=${encodeURIComponent(includeSchedule)}
		&includeRules=${encodeURIComponent(includeRules)}
		&sourceId=${encodeURIComponent(sourceId)}
		&teacherId=${encodeURIComponent(teacherId)}`
			)
			.then((data) => {
				return data.result;
			});
		return response;
	} else {
		return await clsApi
			.Get<ClassroomDetailsResponseDTO>(
				`groups/${encodeURIComponent(classroomId)}?
			includeMembers=${encodeURIComponent(includeStudents)}
			&includeOwners=${encodeURIComponent(includeTeachers)}
			&includeSchedule=${encodeURIComponent(includeSchedule)}
			&includeRules=${encodeURIComponent(includeRules)}
			&sourceId=${encodeURIComponent(sourceId)}
			&teacherId=${encodeURIComponent(teacherId)}`
			)
			.then((data) => {
				return data.result;
			});
	}
};

export const getSubgroups = async (groups: string[]): Promise<string[]> => {
	return await clsApi.Get(`subgroups?groups=${groups.join(",")}`);
};
